<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('drives')"
      :columns="columns"
      :column_search="true"
      resource_url="/drive/datatables"
      mode="grid"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div>
            <figure class="image is-64x64 m-auto" @click="file_list(item)">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3767/3767084.png"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="file_list(item)">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ item.name }}
                </p>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div>
        <!-- <div class="card">
          <header class="card-header">
            <p class="card-header-title">{{ item.name }}</p>           
          </header>
          <div class="card-content">
            <div class="content">
              {{ item }}
              <br />
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item button">
              <span class="icon"><i class="fa fa-edit"></i></span>
              <span>{{ $t("edit") }}</span>
            </a>
            <a class="card-footer-item button" @click="delete_report(item)">
              <span class="icon"><i class="fa fa-trash"></i></span>
              <span>{{ $t("delete") }}</span>
            </a>
            <a class="card-footer-item button" @click="execute_report(item)">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("execute") }}</span>
            </a>
          </footer>
        </div> -->
      </template>
    </generic-table>
  </div>

  <drive-modal ref="drive_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date,
} from "@/utils";
import DriveModal from "./drive_modal/Index.vue";

export default {
  name: "DrivesDatatable",
  components: { GenericTable, DriveModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "create_date",
          width: "20%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.format_date(row.create_date) || "";
          },
        },
        {
          title: v.$t("name"),
          name: "name",
          width: "50%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        // {
        //   title: v.$t("path"),
        //   name: "path",
        //   width: "20%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return row.path || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "30%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.drive_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete drive?"),
                    v,
                    () => {
                      del("/drive", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("file list"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  v.$router.push({
                    path: "/drive/file",
                    query: { u: e.detail.uuid },
                  });
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    create() {
      let v = this;
      v.$refs.drive_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(drive) {
      this.$refs.drive_modal.show_modal(drive.uuid);
    },
    remove(drive) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete drive?"), v, () => {
        del("/drive", { uuid: drive.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    file_list(drive) {
      this.$router.push({
        path: "/drive/file",
        query: { u: drive.uuid },
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.grid .cell .card figure:hover {
  transition: linear 0.1s;
  transform: scale(1.2, 1.2);
}
</style>
